import styles from "styles/AddToBasketBtn.module.scss";
import { BasketContext } from "context/BasketContext";
import { useContext } from "react";
import GetIcon from "components/GetIcon";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const AddToBasketBtn = ({ data: product }) => {
    const { basketItems, setBasketItems, setBasketTotal, currentQuantity, setItemStocks } = useContext(BasketContext);

    const addToBasket = (product) => {
        let newBasketItems = [...basketItems];
        let itemIndex = newBasketItems.findIndex((item) => item.id === product.id);

        if (itemIndex !== -1) {
            const newQuantity = Math.min(newBasketItems[itemIndex].quantity + currentQuantity, product.quantity);
            newBasketItems[itemIndex].quantity = newQuantity;
        } else {
            newBasketItems.push({
                id: product.id,
                title: product.title,
                image_url: product.image_url,
                price: product.price,
                quantity: Math.min(currentQuantity, product.quantity),
            });
            // Set the stock for this item in the context
            setItemStocks((prevStocks) => ({ ...prevStocks, [product.id]: product.quantity }));
        }

        setBasketItems(newBasketItems);
        setBasketTotal((oldTotal) => oldTotal + product.price * Math.min(currentQuantity, product.quantity));

        toast.success("Producto añadido al carrito exitosamente!", {
            position: "bottom-right",
            autoClose: 700,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
                backgroundColor: '#4caf50',
                color: 'white',
                fontWeight: 'bold',
            },
            progressStyle: {
                backgroundColor: 'white',
            },
            icon: ({ theme, type }) => (
                <GetIcon icon="BsCheckCircleFill" size={24} color="white" />
            ),
        });
    };

    return (
        <button
            className={styles.addToBasket}
            onClick={(e) => {
                e.preventDefault();
                addToBasket(product);
            }}
        >
            <GetIcon icon="BsFillCartPlusFill" size={18} /> Añadir
        </button>
    );
};

export default AddToBasketBtn;
